import React from "react";
import { Button, TileTitle, TileSubtitle, Tile, TileBody, TileItem } from "aible";

import createBlueprintIcon from "images/tileIcons/blueprint.svg";

import styles from "./style.module.css";

export default class BlankUseCaseTile extends React.PureComponent {
  render() {
    const { onClick } = this.props;

    return (
      <Tile onClick={onClick} isTileClick>
        <TileBody>
          <div className={styles.blankUseCaseIconWrapper}>
            <div className={styles.blankUseCaseIcon}>
              <img src={createBlueprintIcon} alt={"Blank Use Case"} />
            </div>
            <div className={styles.blankUseCaseTitle}>{"Blank Use Case"}</div>
          </div>
          <div className={styles.blankUseCaseBody}>
            <div className={styles.blankUseCaseText}>{"Add a use case anytime or continue with a blank use case"}</div>
          </div>
        </TileBody>
      </Tile>
    );
  }
}
